import { action } from 'typesafe-actions';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { IDecisionPreview } from 'ApiPackage/SearchModule/interfaces/IDecisionPreview';

import { PassportKnmActionsEnum } from '../enums/PassportKnmActionsEnum';

export const passportKnmGetData = (id: string) => action(PassportKnmActionsEnum.PASSPORT_KNM_GET_DATA, { id });
export const passportKnmGetDataByQr = (token: string) =>
  action(PassportKnmActionsEnum.PASSPORT_KNM_GET_DATA_BY_QR, { token });
export const passportKnmSetData = (data: IKnmPreview) => action(PassportKnmActionsEnum.PASSPORT_KNM_SET_DATA, { data });
export const passportKnmSetErrorStatus = (errorStatus: number) =>
  action(PassportKnmActionsEnum.PASSPORT_KNM_SET_ERROR_STATUS, { errorStatus });
export const passportKnmExportPdf = () => action(PassportKnmActionsEnum.PASSPORT_KNM_EXPORT_PDF);

export const passportDecisionGetData = (id: string) =>
  action(PassportKnmActionsEnum.PASSPORT_DECISION_GET_DATA, { id });
export const passportDecisionGetDataByQr = (token: string) =>
  action(PassportKnmActionsEnum.PASSPORT_DECISION_GET_DATA_BY_QR, { token });
export const passportDecisionSetData = (data: IDecisionPreview) =>
  action(PassportKnmActionsEnum.PASSPORT_DECISION_SET_DATA, { data });
export const passportDecisionExportPdf = () => action(PassportKnmActionsEnum.PASSPORT_DECISION_EXPORT_PDF);
